import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '@letly/ui-common';
import { AppUpdateService } from '../services/app-update.service';

@Component({
  selector: 'app-update-notice',
  imports: [ButtonComponent, MatIconModule],
  templateUrl: './app-update-notice.component.html',
  standalone: true,
})
export class AppUpdateNoticeComponent {
  private readonly appUpdate = inject(AppUpdateService);

  protected readonly refreshLabel = $localize`:@@core.update.notice.refresh:Refresh`;

  refresh(): void {
    this.appUpdate.applyUpdate();
  }

  dismiss(): void {
    this.appUpdate.dismissNotice();
  }
}
